import { Component, Output, OnInit, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MailboxService } from '../mailbox-service/mailbox.service';
import { UIRouter, Transition } from "@uirouter/angular";
import swal from "sweetalert2";
import { Cookie } from 'ng2-cookies';

@Component({
  selector: 'app-mailbox-preview',
  templateUrl: './mailbox-preview.component.html',
  styleUrls: ['./mailbox-preview.component.less']
})
export class MailboxPreviewComponent implements OnInit {

  @Output() 
  mailboxEmailEvent: EventEmitter<any> = new EventEmitter();
  private attachment
	private emailId
  private email
  private authToken

  constructor(private transition: Transition, private mailboxService : MailboxService, private router: UIRouter) {
  		  	this.authToken = Cookie.get('membrs');
  }

  ngOnInit() {
    
    console.log('mailbox preview ngOnInit')

    this.mailboxService.emailId = this.transition.params().id

     this.mailboxService.selectedEmail.subscribe((x)=>{
                this.email = x   
            })

      

  }

  deleteEmail(id) {
      
     swal({   
            title: "Are you sure you want to delete this email?",   
            type: "warning",   
            showCancelButton: true,   
            confirmButtonColor: "#149fba",   
            confirmButtonText: "Yes, delete it", 
        })
        .then((selection) => {
            
            this.mailboxService.emailId = id;   
            this.mailboxService.deleteEmail();
            //How do I stop this running until deleteEmail has completed?
            //this.mailboxService.retrieveEmails();

        })
        .catch(swal.noop);

  }

  markAsSpam(id) {

    swal({   
            title: "Are you sure you want to mark this email as spam?",   
            type: "warning",   
            showCancelButton: true,   
            confirmButtonColor: "#149fba",   
            confirmButtonText: "Yes, it's spam!", 
        })
        .then((selection) => {
            
            this.mailboxService.emailId = id;   
            this.mailboxService.markAsSpam();
            //this.mailboxService.retrieveEmails();

        })
        .catch(swal.noop);

  }

  showProductForm(id) {

    this.router.stateService.go('app.mailbox.overlay', {id: id})

  }

  sendReply(id){
    
    this.router.stateService.go('app.mailbox.email.reply',{fromId:id})

  }

}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/cycler/apollo-admin/src/src/app/mailbox-preview/mailbox-preview.component.ts